import { defineMessages } from 'react-intl';

/** The copy of the release-day cards and the claim-flow note (design release-kit g3). */
export const releaseMessages = defineMessages({
  linkedTitle: { id: 'app.sml.catalog.release.linkedTitle', defaultMessage: '{title} is out.' },
  linkedBody: {
    id: 'app.sml.catalog.release.linkedBody',
    defaultMessage:
      'We found it on the services and linked it to your catalog row. The master and everything you made for it moved with it.',
  },
  linkedFound: {
    id: 'app.sml.catalog.release.linkedFound',
    defaultMessage:
      '{count, plural, =0 {We linked it to your catalog row.} one {We found it on # service and linked it to your catalog row.} other {We found it on # services and linked it to your catalog row.}}',
  },
  movedWith: { id: 'app.sml.catalog.release.movedWith', defaultMessage: '{items} moved with it.' },
  movedMaster: { id: 'app.sml.catalog.release.movedMaster', defaultMessage: 'the master' },
  movedReels: {
    id: 'app.sml.catalog.release.movedReels',
    defaultMessage: '{count, plural, one {# reel} other {# reels}}',
  },
  movedPresave: { id: 'app.sml.catalog.release.movedPresave', defaultMessage: 'the pre-save' },
  seeRelease: { id: 'app.sml.catalog.release.seeRelease', defaultMessage: 'See the release' },
  close: { id: 'app.sml.catalog.release.close', defaultMessage: 'Close' },
  askTitle: { id: 'app.sml.catalog.release.askTitle', defaultMessage: 'Is this {title}?' },
  askBody: {
    id: 'app.sml.catalog.release.askBody',
    defaultMessage:
      'A new track on your profile looks like your unreleased row. Confirm it, and everything on the row moves to the released track.',
  },
  yourRow: { id: 'app.sml.catalog.release.yourRow', defaultMessage: 'Unreleased · your row' },
  outOn: { id: 'app.sml.catalog.release.outOn', defaultMessage: 'Out {date}' },
  yes: { id: 'app.sml.catalog.release.yes', defaultMessage: 'Yes, link it' },
  no: { id: 'app.sml.catalog.release.no', defaultMessage: 'No' },
  claimNoteTitle: {
    id: 'app.sml.catalog.release.claimNoteTitle',
    defaultMessage: 'You already have {title} as an unreleased song.',
  },
  claimNoteBody: {
    id: 'app.sml.catalog.release.claimNoteBody',
    defaultMessage: 'Link this track to it, and the master and the pre-save stay together.',
  },
  claimNoteLink: { id: 'app.sml.catalog.release.claimNoteLink', defaultMessage: 'Link it to {title} (unreleased)' },
  claimNoteNew: { id: 'app.sml.catalog.release.claimNoteNew', defaultMessage: 'Add as a new row' },
});
